import { BaseError } from './base.js';
export class AuthenticationError extends BaseError {
    httpStatus = 403;
}
